import type { LineItem } from "@/models";

export function getActiveUniqueLineItems(lineItems: LineItem[] = []): LineItem[] {
  const uniqueLineItems = new Map<string, LineItem>();
  const lineItemsWithoutIds: LineItem[] = [];

  for (const lineItem of lineItems) {
    if (lineItem.deleted) continue;

    if (!lineItem.id) {
      lineItemsWithoutIds.push(lineItem);
      continue;
    }

    uniqueLineItems.set(lineItem.id, lineItem);
  }

  return [...uniqueLineItems.values(), ...lineItemsWithoutIds];
}

export function upsertLineItemById(lineItems: LineItem[], lineItem: LineItem): LineItem[] {
  if (!lineItem.id) {
    return getActiveUniqueLineItems([...lineItems, lineItem]);
  }

  const withoutCurrentItem = lineItems.filter((item) => item.id !== lineItem.id);
  return getActiveUniqueLineItems([...withoutCurrentItem, lineItem]);
}

export function getVerifiedLineItemsForPdf(lineItems: LineItem[] = []): LineItem[] {
  return getActiveUniqueLineItems(lineItems).filter((lineItem) => lineItem.verified === true);
}

export function copyLineItemForNewEntry(lineItem: Partial<LineItem>): Partial<LineItem> {
  return {
    ...lineItem,
    id: "",
    createdAt: new Date(),
    verified: false,
    files: [],
  };
}
